import { isEmpty } from 'lodash'

export const updatedItemsWithDefaultSelectedItem = (
  updatedItems,
  defaultSelectedItems
) => {
  if (isEmpty(defaultSelectedItems)) {
    return updatedItems
  }

  if (isEmpty(updatedItems)) {
    return defaultSelectedItems
  }

  const updatedItemsUuids = updatedItems?.map((item) => item.uuid)
  const defaultSelectedItemsUuids = defaultSelectedItems?.map(
    (item) => item.uuid
  )

  const duplicatedUuids = updatedItemsUuids.filter((uuid) =>
    defaultSelectedItemsUuids.includes(uuid)
  )

  // defaultSelectedItems without duplicates
  const defaultSelectedItemsWithoutDuplicates =
    defaultSelectedItems.filter(
      ({ uuid }) => !updatedItemsUuids.includes(uuid)
    )

  // all items without duplicates
  const allItemsWithoutDuplicates = [
    ...updatedItems,
    ...defaultSelectedItemsWithoutDuplicates,
  ]

  // items with overwriten ItemCategoriesUuids and itemPreverences
  const itemsWithOverwritenProperties =
    allItemsWithoutDuplicates.reduce((acc, item) => {
      if (duplicatedUuids?.includes(item.uuid)) {
        // duplicate of defaultSelectedItems
        const defaultSelectedItemsDuplicate =
          defaultSelectedItems.find(({ uuid }) => uuid === item.uuid)

        // overwrite current item with properties changed in defaultSelectedItem
        return [
          ...acc,
          {
            ...item,
            itemCategoryExternalRefIds:
              defaultSelectedItemsDuplicate.itemCategoryExternalRefIds,
            itemCategoryPreferences:
              defaultSelectedItemsDuplicate.itemCategoryPreferences,
          },
        ]
      }

      return [...acc, item]
    }, [])

  return itemsWithOverwritenProperties
}
